import { useEffect } from 'react';
import { trackCopyCode } from './analytics';

const CODE_SELECTORS = ['pre', 'code', '[data-copy]'];

// Document-level listener: fires copy_code whenever a user copies from a
// <pre>, <code>, or [data-copy] element. Safe to mount once at app level —
// it does not interfere with copy events outside those elements.
export function useCopyTracking() {
  useEffect(() => {
    function onCopy(e) {
      const isCodeBlock = CODE_SELECTORS.some(sel => e.target.closest(sel));
      if (!isCodeBlock) return;
      const snippet = window.getSelection()?.toString() || '';
      trackCopyCode({ content_snippet: snippet });
    }

    document.addEventListener('copy', onCopy);
    return () => document.removeEventListener('copy', onCopy);
  }, []);
}
